<template>
    <!-- ContractSearchItem.vue -->
    <base-search-item :to="contractUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {CONTRACT_ICON} from '@/store/static/base-icons'
    import {CONTRACT} from '@/router/contract/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'ContractSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: CONTRACT_ICON
            }
        },
        computed: {
            contractUrl () {
                const vm = this
                return {
                    name: CONTRACT,
                    params: {
                        contractId: vm.item.id
                    }
                }
            }
        }
    }
</script>
